import { Common } from './common';
import { Transcript } from './models/transcript';

export class API {
  common: Common;
  constructor(common: Common) {
    this.common = common;
  }

  async findByRecordingId(recordingId: string): Promise<Transcript[]> {
    const url = this.common.constructPath(`/transcript/${recordingId}`);
    const { transcripts } = await this.common.getJSON(url);
    return transcripts;
  }

  async redoTranscription(recordingId: string): Promise<Transcript[]> {
    const url = this.common.constructPath(`/transcript/${recordingId}/redo`);
    return this.common.postJSON(url, {});
  }
}
